import { Suspense } from 'react'
import Field from '../../../../fields'
import { ALLERGY_OPTIONS } from '../constants'
import EditProfileCard, { CardFields, segmentedRadio } from '../EditProfileCard'

type PersonalDetailsCardProps = {
  fields: Record<string, any>
  formId: string
  accountFieldsOnly?: boolean
  testId?: string
}

const PersonalDetailsCard = ({
  fields,
  formId,
  accountFieldsOnly = false,
  testId
}: PersonalDetailsCardProps) => {
  return (
    <EditProfileCard title="Personal details" testId={testId}>
      <Suspense fallback={<div>Loading...</div>}>
        <CardFields>
          {/* The birthdate field renders its own age pill (compact, so the
              input stays aligned with the fields below). CM-3877 */}
          <Field
            className="dateofbirth-field"
            keys="dateOfBirth"
            placeholders="DD-MM-YYYY"
            formId={formId}
            label="Date of birth"
            type="birthdate"
            compactAge
            validationTypes="birthdate"
            disabled={accountFieldsOnly}
            values={fields}
          />
          <Field
            className="address-field"
            formId={formId}
            keys="address"
            label="Address"
            type="address"
            disabled={accountFieldsOnly}
            readOnly={accountFieldsOnly}
            values={fields}
          />
          <Field
            className="phonenumber-field"
            formId={formId}
            keys="phoneNumber"
            label="Personal telephone number"
            options={{ phone: true, phoneRegionCode: 'GB' }}
            type="formattedText"
            disabled={accountFieldsOnly}
            readOnly={accountFieldsOnly}
            values={fields}
          />
          <Field
            className="allergies-field"
            keys="hasAllergies"
            label="Allergies"
            formId={formId}
            options={ALLERGY_OPTIONS}
            type="radios"
            disabled={accountFieldsOnly}
            values={fields}
            {...segmentedRadio}
          />
          <Field
            dependsOn={{ key: 'hasAllergies', value: 'Yes' }}
            keys="allergies"
            required
            label="Allergy details"
            formId={formId}
            type="text"
            disabled={accountFieldsOnly}
            values={fields}
          />
        </CardFields>
      </Suspense>
    </EditProfileCard>
  )
}

export default PersonalDetailsCard
